<script>
import baseMixin from '@mixins/baseMixin'
import TheDebugBar from '@components/dev/the-debug-bar.vue'

export default {
  components: {
    TheDebugBar,
  },
  mixins: [baseMixin],
  props: {
    noGutters: {
      type: Boolean,
    },
    noFillHeight: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <v-app id="client-login">
    <TheDebugBar />
    <v-main class="white">
      <v-container
        :class="[
          noFillHeight ? '' : 'fill-height',
          noGutters ? 'ma-0 pa-0' : '',
        ]"
        fluid
      >
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>
